export default __webpack_public_path__ + "static/media/noresults.d09e692a.svg";